import { AbstractControl } from '@angular/forms';

export class ZipcodeValidator {
  static format(c: AbstractControl): { [key: string]: any; } | null {
    const reg = /^\d+$/;
    if (typeof c.value === 'undefined' || c.value === null || c.value.toString().trim().length === 0) {
      return null;
    }

    if (c.value.toString().trim().length > 9 || !reg.test(c.value)) {
      return { zipcodeFormat: 'ZIP code must be numeric and no more than 9 digits' };
    }
    return null;
  }

  static billingFormat(c: AbstractControl): { [key: string]: any; } | null {
    if (c.value === null || typeof c.value === 'undefined' || c.value.toString().trim().length === 0) {
      return null;
    }

    if (c.value.toString().trim().length !== 5) {
      return { invalidLength: 'ZIP code must be 5 digits' };
    }
    return null;
  }
}
